import clsx from 'clsx';
import { add, getMonth, getYear } from 'date-fns';
import range from 'lodash/range';
import { useMemo } from 'react';

const MONTHS = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
].map((m, i) => ({
  index: i,
  short: `${m}`.slice(0, 3),
  long: m,
}));

export function CustomDateHeader({
  datePickerProps,
  date,
  customHeaderCount,
  monthDate,
  changeMonth,
  changeYear,
  decreaseMonth,
  increaseMonth,
  decreaseYear,
  increaseYear,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  prevYearButtonDisabled,
  nextYearButtonDisabled,
}) {
  const years = useMemo(() => {
    if (!datePickerProps) return range(getYear(new Date()), getYear(new Date()) + 2);
    /** @type {import('react-datepicker').DatePickerProps} */
    const props = datePickerProps;

    let minDate = props.minDate || new Date();
    let maxDate = props.maxDate || add(new Date(), { years: 2 });

    return range(getYear(minDate), getYear(maxDate) + 1);
  }, [datePickerProps]);

  return (
    <div className="custom-date-header">
      <div className="date-header-row">
        <div className="date-select-wrapper">
          <span
            role="button"
            className={clsx('select-btn', prevMonthButtonDisabled && 'disabled')}
            onClick={(ev) => {
              ev.preventDefault();
              if (prevMonthButtonDisabled) return;
              decreaseMonth();
            }}
          >
            <img className="date-arrow" src="assets/shared/ic-date-arrow-l.svg" alt="" />
          </span>
          <select
            className="date-select date-select-month"
            value={MONTHS[getMonth(date)].short}
            onChange={({ target: { value } }) => {
              changeMonth(MONTHS.find((m) => m.short === value).index);
            }}
          >
            {MONTHS.map((option) => (
              <option key={option.short} value={option.short}>
                {option.short}
              </option>
            ))}
          </select>
          <span
            role="button"
            className={clsx('select-btn', nextMonthButtonDisabled && 'disabled')}
            onClick={(ev) => {
              ev.preventDefault();
              if (nextMonthButtonDisabled) return;
              increaseMonth();
            }}
          >
            <img className="date-arrow" src="assets/shared/ic-date-arrow-r.svg" alt="" />
          </span>
        </div>
        <div className="date-select-wrapper">
          <span
            role="button"
            className={clsx('select-btn', prevYearButtonDisabled && 'disabled')}
            onClick={(ev) => {
              ev.preventDefault();
              if (prevYearButtonDisabled) return;
              decreaseYear();
            }}
          >
            <img className="date-arrow" src="assets/shared/ic-date-arrow-l.svg" alt="" />
          </span>
          <select
            className="date-select"
            value={years.find((y) => y === getYear(date))}
            onChange={({ target: { value } }) => changeYear(value)}
          >
            {years.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          <span
            role="button"
            className={clsx('select-btn', nextYearButtonDisabled && 'disabled')}
            onClick={(ev) => {
              ev.preventDefault();
              if (nextYearButtonDisabled) return;
              increaseYear();
            }}
          >
            <img className="date-arrow" src="assets/shared/ic-date-arrow-r.svg" alt="" />
          </span>
        </div>
      </div>
    </div>
  );
}
